import { storeToRefs } from 'pinia'
import { useQueryClient } from '@tanstack/vue-query'
import { usePropertiesStore } from '@/store/properties'
import type { PropertyType } from '@/interfaces'
import { selectableProperties } from '@/utils/displayable-property'

export const useCurrentPropertyId = () => {
  const propertiesStore = usePropertiesStore()
  const { currentPropertyId } = storeToRefs(propertiesStore)
  let queryClient: ReturnType<typeof useQueryClient> | undefined
  try {
    queryClient = useQueryClient()
  } catch {
    queryClient = undefined
  }

  function setCurrentProperty(id: number) {
    const cachedProperties = queryClient?.getQueryData<PropertyType[]>([
      'properties'
    ])
    if (!cachedProperties) return

    if (
      selectableProperties(cachedProperties).some(
        (property) => property.id === id
      )
    ) {
      currentPropertyId.value = id
    }
  }

  return { currentPropertyId, setCurrentProperty }
}
